import React, { useEffect } from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { LumoChatProvider } from "./contexts/LumoChatContext";
import { TenantProvider } from "./contexts/TenantContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

function App() {
  console.log('App component rendering');
  
  useEffect(() => {
    // Register service worker for PWA
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker registered:', registration);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    }
  }, []);
  
  const queryClient = React.useMemo(() => new QueryClient({
    defaultOptions: {
      queries: {
        // Avoid refetch spinner on tab focus; keep cached data warm
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
        retry: 1,
        staleTime: 5 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        placeholderData: (prev) => prev,
      },
    },
  }), []);
  
  return (
    <ThemeProvider>
      <TenantProvider>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <LumoChatProvider>
              <Routes />
              <PWAInstallPrompt />
            </LumoChatProvider>
          </QueryClientProvider>
        </AuthProvider>
      </TenantProvider>
    </ThemeProvider>
  );
}

export default App;